import DocumentationLink, {DocumentationSideLink} from "./DocumentationLink";

export default DocumentationLink;

export { DocumentationLink, DocumentationSideLink };
